import "./DirectBookingGrowthServices.module.css";
import Header from "@/reusable_sections/Header";
import DirectBookingHero from "./sections/DirectBookingHero";
import Contact from "./sections/Contact";
import RevenuePillars from "./sections/RevenuePillars";
import BookingStrategyFAQ from "./sections/BookingStrategyFAQ";
import DirectBookingGrowth from "./sections/DirectBookingGrowth";
import Footer from "@/reusable_sections/Footer";
export default function DirectBookingGrowthServicesPage() {
  return <div>
      <Header />
      <DirectBookingHero />
      <Contact />
      <RevenuePillars />
      <BookingStrategyFAQ />
      <DirectBookingGrowth />
      <Footer />
    </div>;
}